import React, {useState} from 'react';
import './BisPasswordfield.css';
import PropTypes from "prop-types";
import {EyeNoneIcon, EyeOpenIcon} from '@radix-ui/react-icons';

const BisPasswordfield = ({id, label, value, onChange, readOnly = false, error}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    return (
        <div className="bis_passwordfield">
            <label className="bis_passwordfield-label" htmlFor={id}>{label}</label>
            <div className="bis_passwordfield-input-wrapper">
                <input
                    id={id}
                    className={`bis_passwordfield-input ${readOnly ? 'readonly' : ''}`}
                    type={showPassword ? "text" : "password"}
                    value={value}
                    onChange={onChange}
                    readOnly={readOnly}
                    aria-readonly={readOnly ? "true" : "false"}
                    aria-describedby={error ? `${id}-error` : undefined}
                    aria-invalid={error ? "true" : "false"}
                />
                <button
                    type="button"
                    className="bis_passwordfield-toggle"
                    onClick={togglePasswordVisibility}
                    aria-label={showPassword ? "Passwort verbergen" : "Passwort anzeigen"}
                    disabled={readOnly}
                >
                    {showPassword ? <EyeNoneIcon/> : <EyeOpenIcon/>}
                </button>
            </div>
            {error && (
                <div id={`${id}-error`} className="bis_passwordfield-error show" role="alert">
                    {error}
                </div>
            )}
        </div>
    );
};

BisPasswordfield.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    error: PropTypes.string,
};

export default BisPasswordfield;
